import Notify from "../components/Notify"

export default {
    install(Vue, options) {
        Vue.prototype.$notif = new Vue({
            data: {
                messages: {}
            },
            methods: {
                delete(key) {
                    Vue.delete(this.messages, key)
                },
                clean() {
                    for (const key in this.messages) {
                        if (!this.messages[key]) {
                            this.delete(key)
                        }
                    }
                }
            }
        })
        Vue.component("Notify", Notify)
        let counter = 0
        Vue.prototype.$notify = ({ title, type, message, timeout = 2500 }) => {
            counter += 1
            Vue.prototype.$notif.clean()
            Vue.set(Vue.prototype.$notif.messages, counter, { title, type, message, timeout })
        }
    }
}
